import { render, staticRenderFns } from "./MasterDataBed.vue?vue&type=template&id=ea5a1faa&scoped=true"
import script from "./MasterDataBed.vue?vue&type=script&lang=js"
export * from "./MasterDataBed.vue?vue&type=script&lang=js"
import style0 from "./MasterDataBed.vue?vue&type=style&index=0&id=ea5a1faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5a1faa",
  null
  
)

export default component.exports